<button type="button" (click)="click($event)" class="ex-btn" [style]="btnStyle">{{ text }}</button>